// src/config.js

// نحدد البيئة الحالية (development أو production)
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

// إعدادات البيئات المختلفة
const config = {
  local: {
    API_URL: process.env.REACT_APP_API_URL || "http://localhost:8000",
    MODE: "local",
  },
  development: {
    API_URL: process.env.REACT_APP_API_URL || "https://deliveritdev2.deliverit.cc",
    MODE: "Development",
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL || "https://api.deliverit.cc",
    MODE: "Production",
  },
};


// نُصدر الإعدادات المناسبة حسب البيئة
export default config[ENV];
